module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/T5T7iw/tc-custom/9781625847737.jpg?1702083505711",
      "alt": "This image is the cover for the book Jersey Shore Thrill Killer"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Jersey Shore Thrill Killer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The true story of the murders that terrorized New Jersey beach towns for nearly a decade.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Beachgoers usually watch out for dangers like riptides or sharks—but from 1974 to 1983, a different fear gripped the New Jersey shore: young women were disappearing. Their abductor was Richard Biegenwald, a man released for good behavior after serving seventeen years in prison for murder and spending time in a psychiatric facility."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Police arrested him on suspicion of rape, and it was not until they connected him to a woman’s death in Asbury Park that he finally stopped his rampage. Investigators later linked him to nine murders and convicted him of five. In this account, former New Jersey state trooper John O’Rourke narrates the chilling story of the Jersey Shore Thrill Killer.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John E. O'Rourke\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("John E. O'Rourke was born in Pequannock, New Jersey, and raised in the Passaic County town of Wanaque. He is a retired New Jersey State Trooper with twenty-six years of experience with the elite organization. During his distinguished career, he conducted hundreds of criminal investigations ranging from criminal trespass to murder. He is the author of Jersey Troopers: Sacrifice at the Altar of Public Service\" and \"New Jersey State Troopers: 1961, 2011, Remembering the Fallen.\"")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0